<script lang="ts">
  import Button from '$lib/components/Button.svelte';
  import MaterialIcon from '$lib/MaterialIcon.svelte';
  import { mdiChevronLeft, mdiChevronRight } from '@mdi/js';
  import { createEventDispatcher } from 'svelte';

  export let hidePrev = false;
  export let hideNext = false;
  export let disableNext = false;
  export let disablePrev = false;

  interface $$Events {
    nextClicked: CustomEvent<null>;
    prevClicked: CustomEvent<null>;
  }

  const dispatch = createEventDispatcher<$$Events>();
</script>

<div class="flex justify-between">
  {#if !hidePrev}
    <Button disabled={disablePrev} on:click={() => dispatch('prevClicked')}>
      <span class="sr-only">Previous Page</span>
      <MaterialIcon path={mdiChevronLeft} label="Previous Page" />
    </Button>
  {/if}
  {#if !hideNext}
    <Button disabled={disableNext} on:click={() => dispatch('nextClicked')}>
      <span class="sr-only">Next Page</span>
      <MaterialIcon path={mdiChevronRight} label="Previous Page" />
    </Button>
  {/if}
</div>
